<fui-rows>
    <fui-row>
        <fui-column>
            <wbo-edit-grid [data]="model.data.accountPins" [editable]="true"
                           [removable]="true" [rowRemovable]="rowRemovable"
                           [entityPath]="'accountPins'">
                <wbo-edit-link-column field="account.details.accountName" componentPath="account"
                                      [editComponent]="AccountEditPageComponent"
                                      [editMode]="EditMode.VIEW"></wbo-edit-link-column>
                <wbo-text-column field="pin" [editable]="true"></wbo-text-column>
                <wbo-checkbox-column field="defaultContact" [editable]="false"></wbo-checkbox-column>
                <wbo-checkbox-column field="statementContact" [editable]="false"></wbo-checkbox-column>
                <wbo-checkbox-column field="invoiceContact" [editable]="false"></wbo-checkbox-column>
                <wbo-edit-grid-add-row [componentPath]="'account'" [customAdd]="true">
                    <wbo-edit-grid-add-row-quick-add (onSelect)="addAccountFromSearch([$event])">
                        <wbo-account-single-select-edit-control></wbo-account-single-select-edit-control>
                    </wbo-edit-grid-add-row-quick-add>
                    <wbo-edit-grid-add-row-actions>
                        <wbo-edit-grid-add-row-search (onSelect)="addAccountFromSearch($event)"
                                                      [searchComponent]="AccountSearchPageComponent"
                                                      [searchParams]="{disableAddNew: true}"></wbo-edit-grid-add-row-search>
                        <wbo-edit-grid-add-row-new-entity *ngIf="editService.editMode !== EditMode.ADD"
                                                          (onSelect)="addAccountFromNew($event)"
                                                          [editComponent]="AccountEditPageComponent"
                                                          [parentEntity]="model.data"></wbo-edit-grid-add-row-new-entity>
                    </wbo-edit-grid-add-row-actions>
                </wbo-edit-grid-add-row>
            </wbo-edit-grid>
        </fui-column>
    </fui-row>
</fui-rows>
